import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";

const unLockContributorShotClass = (classId) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.SOCIAL.MODERATE_CONTRIBUTIONS.UNLOCK_CONTRIBUTOR_SHOTCLASSES(
      classId
    )
  );
};

export default unLockContributorShotClass;
